import { Link, useLocation } from "react-router-dom";
import { Radar, CalendarDays, ScrollText, Activity, User } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { usePlan } from "@/context/PlanContext";

const TABS = [
  { to: "/scanner", label: "Scan", icon: Radar, testid: "tab-scanner" },
  { to: "/catalysts", label: "Catalysts", icon: CalendarDays, testid: "tab-catalysts" },
  { to: "/journal", label: "Journal", icon: ScrollText, testid: "tab-journal" },
  { to: "/stats", label: "Stats", icon: Activity, testid: "tab-stats" },
];

export default function MobileTabBar() {
  const loc = useLocation();
  const { user, openAuth } = useAuth();
  const { pro } = usePlan();
  const active = (to) => loc.pathname === to || (to === "/scanner" && loc.pathname === "/");
  const meActive = ["/account", "/portfolio", "/watchlist", "/pricing", "/admin/codes", "/admin/team"].includes(loc.pathname);

  const Tab = ({ to, label, icon: Icon, isActive, onClick, testid, dot }) => {
    const cls = `tap relative flex flex-col items-center justify-center gap-0.5 flex-1 h-full text-[10px] font-semibold tracking-wide transition-colors ${isActive ? "text-emerald-400" : "text-slate-500"}`;
    const inner = (
      <>
        {isActive && <span className="absolute top-0 h-0.5 w-8 rounded-full bg-emerald-400 shadow-[0_0_10px_rgba(0,255,102,0.8)]" />}
        <span className={`relative flex items-center justify-center h-7 w-7 rounded-xl transition-colors ${isActive ? "bg-emerald-500/12" : ""}`}>
          <Icon className="h-[22px] w-[22px]" strokeWidth={isActive ? 2.4 : 1.9} />
          {dot && <span className="absolute -top-0.5 -right-0.5 h-2 w-2 rounded-full bg-amber-400 shadow-[0_0_8px_rgba(255,184,0,0.9)]" />}
        </span>
        {label}
      </>
    );
    return to ? <Link to={to} className={cls} data-testid={testid}>{inner}</Link> : <button onClick={onClick} className={cls} data-testid={testid}>{inner}</button>;
  };

  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-50 glass border-t border-[#222F43] safe-bottom" data-testid="mobile-tab-bar">
      <div className="flex items-stretch h-16">
        {TABS.map((t) => <Tab key={t.to} {...t} isActive={active(t.to)} />)}
        {user
          ? <Tab to="/account" label="Me" icon={User} isActive={meActive} testid="tab-me" dot={!pro} />
          : <Tab onClick={openAuth} label="Sign in" icon={User} isActive={false} testid="tab-me" />}
      </div>
    </nav>
  );
}
